import { ClipLoader } from "react-spinners";

const WalletSkeleton = () => {
  return (
    <div className="w-full min-w-[320px] mt-12 px-[20px] md:px-[40px] lg:px-[100px] mb-[88px]">
      <div className="bg-white border border-light-blue rounded-[20px] p-5 md:p-7 lg:p-9 flex flex-col gap-5 lg:gap-6">
        <div className="flex flex-row flex-wrap justify-between items-center">
          {/* Wallet Title Skeleton */}
          <div className="w-40 h-6 bg-gray-200 rounded-md animate-pulse"></div>

          {/* Total Amount Skeleton with Spinner */}
          <div className="flex flex-col items-center justify-center rounded-xl md:rounded-2xl gap-1 bg-gray-200 w-[140px] h-[62px] md:w-[200px] md:h-[82px]">
            <ClipLoader size={24} color="white" />
          </div>
        </div>

        {/* Tab Buttons Skeleton */}
        <div className="flex flex-row gap-4 border-b border-light-blue pb-1">
          <div className="w-20 h-6 bg-gray-200 rounded-md animate-pulse"></div>
          <div className="w-20 h-6 bg-gray-200 rounded-md animate-pulse"></div>
        </div>

        {/* Cards Section Skeleton */}
        <div className="flex flex-col gap-4 lg:gap-6 md:gap-5">
          {Array(4).fill(0).map((_, i) => (
            <div
              key={i}
              className="flex flex-row rounded-[20px] py-4 px-6 border border-[#DDE1E6] gap-[24px] items-center animate-pulse"
            >
              {/* Star Icon Skeleton */}
              <div className="hidden md:block w-[50px] h-[50px] bg-gray-200 rounded-[8px]"></div>

              {/* Card Content Skeleton */}
              <div className="flex flex-col h-full justify-between w-full">
                <div className="w-3/4 h-6 bg-gray-200 rounded-md"></div>
                <div className="w-1/2 h-4 bg-gray-200 rounded-md mt-2"></div>
              </div>

              {/* Amount & Date Skeleton */}
              <div className="flex flex-col items-end">
                <div className="w-16 h-6 bg-gray-200 rounded-md"></div>
                <div className="w-24 h-4 bg-gray-200 rounded-md mt-2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WalletSkeleton;
